import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    reportMetaData,
    addIconsToGDTableHeadersList,
    getTranslations,
    getFormattedDimsStatus,
    getFormattedUserType,
    setDeafaultSearchFilterelements,
    setDeafaultSearchFilterelementsforUserReport
} from './configStructure.js';
import {
    getReportNames,
    exportReportData,
    reportData,
    closeCaseStage,
    getProductReportNames
} from 'Apis/reportApi.js';
import {
    exportUserManagerReportData,
    userManagerReportData,
    getFieldName,
    getFilterValuesBasedOnElementIdForUserReport,
    getcolumnKey
} from 'Apis/userManagerReportApi.js';
import {
    getFilterValuesForUserReport,
    getQueueLabels
} from 'Apis/queueManagerApi.js';
import GDTable from 'Components/GDTable';
import EmptyState from 'Components/EmptyState/EmptyState';
import { setDrawerOpenFlag } from 'Actions/drawerAction';

import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import GDDetailView from 'Components/GDDetailView';
import {
    dangerNotificationBanner,
    closeNotificationBanner,
} from 'Actions/notificationAction';
import FloatingPanel from 'Components/FloatingPanel/FloatingPanel';
import {
    formatAvailableFilters,
    formatActiveFilters,
    splitMergedElementIdsFilters,
    mapActiveFilters,
    convertJsonObjectToArray,
    splitMergedElementIdsFilterValues,
    mergeSavedElementIdsForRangeElements,
    mapSavedFilters,
    removeFilterActionSavedFilter,
    splitMergedElementIdsFilterValuesSaveFilter,
} from 'Utils/dynamicListSelectorUtil';
import { loadState } from '../../store/browserStorage';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import classnames from 'classnames';
import FilterPane from 'Components/FilterPane';
import {
    getDynamicFitlersAccToQueueMgmtPage,
    postActiveDynamicFilters,
    postActiveFilterValues,
    getSavedFiltersBasedOnSearchTypeId,
    deleteSavedFilter,
} from 'Apis/searchFilterApi';
import ResponseBanner from 'Components/cards/ResponseBanner';
import GDActiveFiltersDropdown from 'Components/GDActiveFiltersDropdown/GDActiveFiltersDropdown';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import GDNewFilterDropdown from 'Components/GDNewFilterDropdown';
import GDSavedFiltersDropdown from 'Components/GDSavedFiltersDropdown';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import StarIcon from 'Components/icons/StarIcon';
import {
    postActiveFilters,
} from 'Apis/caseDataAPI';
import { sort_by } from 'Utils/functionalUtils.js';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import './ReportView.scss';
import { isObject } from 'util';
import { getToken } from 'Apis/tokenizeFilterElement';
import moment from 'moment';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import {
    getFilterValuesBasedOnElementId,
    getFilterValuesBasedOnElementIdWithAcquirer,
} from 'Apis/caseDataAPI.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { productReportData } from '../../api/reportApi.js';
import ExclamationIcon from 'Components/icons/ExclamationIcon';
import { fetchFilterValuesBasedOnElementId } from 'Apis/queueManagerApi.js';
import { each } from 'Utils/lodashUtils.js';
import ImagePortal from 'Containers/ImagePortal';
export class ReportView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            filters: [],
            isLoading: true,
            scrollPos: 0,
            totalPages: 0,
            caseData: [],
            totalRecords: 0,
            recordsShown: 0,
            currentPage: 0,
            isNextPage: false,
            caseDataErr: false,
            exporting: false,
            filterExportIsVisible: false,
            appliedFilters: [],
            sort: {},
            dateFormat: reportMetaData().dateFormat,
            filterText: '',
            savedFilterTranslations: {},
            isRequiredFilter: false,
            isTableVisible: false,
            apiMultiSelectCount: 0,
            multiSelectLength: 0,
            isLoadingComplete: true,
            dataColumns: [],
            headerCountData: {},
            reportMetaData: reportMetaData(),
            selectedRows: [],
            currentGroupAnalysts: [],
            casesToHide: [],
            totalBulkCases: 0,
            resetCaseCount: false,
            totalRecordsUpdated: -1,
            scrollPos: 0,
            activeFiltersValues: [],
            activeFilters: [],
            availableFilters: [],
            isBookMarked: false,
            filterTypeId: 0,
            dropdownToggled: {
                active: false,
                inactive: false,
            },
            saveFilterToggled: false,
            filterName: '',
            noSavedFilters: false,
            savedFilters: [],
            currentSearchTerm: '',
            savdActiveFilters: [],
            tempSavedFilters: [],
            reportSearchView: {
                "filterTypeId": 0,
                "searchFilterInputElements": []
            },
            saveFilterFail: false,
            reportName: '',
            reportList: [],
            pageListId: '',
            drawerOpen: false,
            reportId: '',
            activeColumnsData: [],
            isApplySummary: false,
            isApplyColumnManager: false,
            isStageClosed: false,
            caseNumber: 0,
            caseType: '',
            actionBtnWidth: 90,
            sortArr: [],
            formattedFilters: [],
            setSize: false,
            isFirstTimeLoad: false,
            isVisibleNew: true,
            enableSaveFilter: false,
            applyAuto: false,
            isFormattedFiltersSet: false,
        };
        this.attachBindings();
    }


    attachBindings() {
        this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
        this.rowActionClick = this.rowActionClick.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
        this.onCheckboxClick = this.onCheckboxClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.closeFilterPane = this.closeFilterPane.bind(this);
        this.toggleFilterPane = this.toggleFilterPane.bind(this);
        this.resetScrollPos = this.resetScrollPos.bind(this);
        this.updateColumnsInfo = this.updateColumnsInfo.bind(this);
        this.fetchDynamicFilterAccToQueueId = this.fetchDynamicFilterAccToQueueId.bind(this);
        this.saveActiveDynamicFilters = this.saveActiveDynamicFilters.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.closeBanner = this.closeBanner.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.deactivateFilter = this.deactivateFilter.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.toggleSavedFilter = this.toggleSavedFilter.bind(this);
        this.saveFilterName = this.saveFilterName.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateSearchField = this.updateSearchField.bind(this);
        this.removeSavedFilter = this.removeSavedFilter.bind(this);
        this.setSavedFilterAsActive = this.setSavedFilterAsActive.bind(this);
        this.applySavedFilterSet = this.applySavedFilterSet.bind(this);
        this.closeSaveFilterFailBanner = this.closeSaveFilterFailBanner.bind(this);
        this.routeToPreviousPage = this.routeToPreviousPage.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.goToNextRecord = this.goToNextRecord.bind(this);
        this.getReportNames = this.getReportNames.bind(this);
        this.getProductReportNames = this.getProductReportNames.bind(this);
        this.closeStageBanner = this.closeStageBanner.bind(this);
        this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.getMultiSelectFilterValues = this.getMultiSelectFilterValues.bind(this);
        this.getFormattedResponse = this.getFormattedResponse.bind(this);
        this.updateIsIndeterminate = this.updateIsIndeterminate.bind(this);
        this.getFormattedResponseCorpRegion = this.getFormattedResponseCorpRegion.bind(this);
        this.groupByRegion = this.groupByRegion.bind(this);
        this.clearGroupSearchValue = this.clearGroupSearchValue.bind(this);


    }

    componentWillMount() {
        scroll(0, 0);
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const auth = loadState('auth');
        const userPermission = auth.user.parsedPermissions;
        const reportId = window.location.href.split('view/')[1];
        const pageId = this.props.location.state && this.props.location.state.pageId;
        document.addEventListener('keydown', this.onKeyPress);
        document.addEventListener('keypress', this.onKeyPress);
        this.setState({
            userPermission,
            reportId,
        });
        let reportMetaDataClone = reportMetaData(userPermission, userId, true, reportId);
        this.setState({
            reportMetaData: reportMetaDataClone,
        });

    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress);
        document.removeEventListener('keypress', this.onKeyPress);
        localStorage.removeItem('pageListId');
        localStorage.removeItem('isProductReportView');
    }

    componentDidMount() {
        let isProductReportView = localStorage.getItem('isProductReportView');
        if (typeof isProductReportView !== "undefined" && isProductReportView === 'true') {
            this.getProductReportNames();
        } else {
            this.getReportNames();
        }
    }

    componentWillUpdate(nextProps, nextState) {

        if (!this.props.fetchDataColumns && nextProps.fetchDataColumns) {

            const reportName = this.state.pageListId;
        }

    }
    componentWillReceiveProps(nextProps) {
        const columns = nextProps.dataColumns?.filter(column => column.userIsVisible === true);
        const activeDataColumns = [];
        columns.forEach((column) => {
            const activeColumn = {
                columnId: column.columnId,
                columnKey: column.columnKey,
            };
            activeDataColumns.push(activeColumn);
        });
        if (this.state.pageListId === 'bre_summary_rpt' && this.state.isApplySummary) {
            this.setState({
                dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                activeColumnsData: activeDataColumns,
            }, () => {
                this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView, this.state.activeColumnsData);
            });
        }

        if ((this.state.pageListId === 'dispute_product_rpt' || this.state.pageListId === 'merchant_gl_rpt') && this.state.isApplySummary) {
            this.setState({
                dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                activeColumnsData: activeDataColumns,
            }, () => {
                this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView, this.state.activeColumnsData);
            });
        }
        if (this.state.pageListId === 'user_report' && this.state.isApplyColumnManager) {
            this.setState({
                dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                activeColumnsData: activeDataColumns,
            }, () => {
                this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView, this.state.activeColumnsData);
            });
        }


        if ((this.props.location !== nextProps.location || this.state?.dataColumns?.length == 0 || this.props?.dataColumns?.length !== nextProps.dataColumns?.length) && !this.state.isApplyColumnManager) {
            if (this.state.reportId === '7') {
                this.setState({
                    activeColumnsData: activeDataColumns,
                    dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                    reportSearchView: {
                        filterTypeId: '88',
                        searchFilterInputElements: setDeafaultSearchFilterelements(),
                    },
                }, () => {
                    if (Object.keys(this.state.sort).length !== 0) {
                        this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView);
                    }
                });
            } else if (this.state.reportId === '8') {
                this.setState({
                    activeColumnsData: activeDataColumns,
                    dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                    reportSearchView: {
                        filterTypeId: '89',
                        searchFilterInputElements: setDeafaultSearchFilterelementsforUserReport(),
                    },
                }, () => {
                    if (Object.keys(this.state.sort).length !== 0) {
                        this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView);
                    }
                });
            }
            else {
                this.setState({
                    activeColumnsData: activeDataColumns,
                    dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.pageListId),
                }, () => {
                    if (Object.keys(this.state.sort).length !== 0) {
                        if (this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) {
                            this.getDataForDetailReport(true, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView);
                        } else {
                            this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView);
                        }
                    }
                });
            }

        }
    }

    componentDidUpdate() {
        if (this.state.caseData.length === 1) {
            const myDiv = document.getElementById("queueManagementLanding");
            if (myDiv !== null) {
                myDiv.style.height = '450px';
            }
        }
    }

    getProductReportNames() {
        this.setState({
            isLoading: true,
        });
        return getProductReportNames()
            .then((apiResponse) => {
                const reportList = apiResponse.data;
                const report = reportList.filter((report) => report.reportId == window.location.href.split('view/')[1])

                this.setState({
                    reportName: report[0].reportName,
                    reportList: reportList,
                    pageListId: report[0].pageListId,
                    sort: reportMetaData().defaultSort[report[0].pageListId],
                    actionBtnWidth: reportMetaData().columnStyle[report[0].pageListId].width,
                });
                localStorage.setItem('pageListId', report[0].pageListId);


                this.props.fetchDataColumns(report[0].pageListId);
                this.fetchDynamicFilterAccToQueueId(report[0].pageListId);
            })
            .catch((error) => {
                this.setState({ reportNames: '', isLoading: false });
            });
    }

    getReportNames() {
        this.setState({
            isLoading: true,
        });
        let acquirerAccessList=getAcquirerAccessList();
        return getReportNames(acquirerAccessList)
          .then((apiResponse) => {
            const reportList = apiResponse.data;
            const report = reportList.filter((report)=> report.reportId == window.location.href.split('view/')[1])
            this.setState({
              reportName: report[0].reportName,
              reportList: reportList,
              pageListId :report[0].pageListId,
              sort : reportMetaData().defaultSort[report[0].pageListId],
              actionBtnWidth : reportMetaData().columnStyle[report[0].pageListId].width,
            });
                this.props.fetchDataColumns(report[0].pageListId);
                this.fetchDynamicFilterAccToQueueId(report[0].pageListId);
            })
            .catch((error) => {
                this.setState({ reportNames: '', isLoading: false });
            });
    }

    onKeyPress(event) {
        const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
        switch (eventCode) {
            case KeyConstants.ESCAPE_BUTTON:
            case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
                this.closeBanner();
                this.closeSaveFilterFailBanner();
                this.closeStageBanner();
                break;
        }
    }


    compare(firstAnalyst, nextAnalyst) {
        // Use toUpperCase() to ignore character casing
        const genreA = firstAnalyst.firstName.toUpperCase();
        const genreB = nextAnalyst.firstName.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
            comparison = 1;
        } else if (genreA < genreB) {
            comparison = -1;
        }
        return comparison;
    }

    getDataForDetailReport(isFirstLoad, reportId, reportName, pageNumber, size, sort, reportSearchView, activeColumns) {
        if (!isFirstLoad) {
            const reportMetaDataClone = { ...this.state.reportMetaData };
            reportMetaDataClone.dataColumns = this.state.dataColumns;
            const activeColumnsList = activeColumns != undefined ? activeColumns : [];
            this.setState({
                isApplySummary: false,
                isApplyColumnManager: false,
                isLoading: true
            })
            let acquirerAccessList = getAcquirerAccessList();
            if (typeof reportName !== "undefined" && reportName !== "Incoming Disputes Report" && reportName !== "Merchant GL Report" && reportName !== "Active Users Report") {
                return reportData(reportId, pageNumber, size, sort, reportSearchView, this.state.activeColumnsData, acquirerAccessList)
                    .then((apiResponse) => {
                        const formattedData = apiResponse.data.content;
                        this.setState((prevState) => ({
                            isFirstTimeLoad: false,
                            reportMetaData: reportMetaDataClone,
                            caseData: formattedData,
                            totalRecords: apiResponse.data.totalElements,
                            totalPages: apiResponse.data.totalPages,
                            currentPage: apiResponse.data.number + 1,
                            recordsShown: size,
                            isNextPage: !apiResponse.data.last,
                            caseDataErr: false,
                            isLoading: false,
                            sort,
                            isTableVisible: true,
                            selectedRows: [],
                            agLoader: false,
                        }));
                        scroll(0, 0);
                    })
                    .catch((error) => {
                        this.setState({ isFirstTimeLoad: false, caseDataErr: true, isLoading: false });
                    });
            } else if (reportName == "Active Users Report") {
                userManagerReportData(reportId, pageNumber, size, sort, reportSearchView, this.state.activeColumnsData, acquirerAccessList)
                    .then((apiResponse) => {
                        const formattedData = apiResponse.data.content;
                        this.setState((prevState) => ({
                            isFirstTimeLoad: false,
                            reportMetaData: reportMetaDataClone,
                            caseData: formattedData,
                            totalRecords: apiResponse.data.totalElements,
                            totalPages: apiResponse.data.totalPages,
                            currentPage: apiResponse.data.number + 1,
                            recordsShown: size,
                            isNextPage: !apiResponse.data.last,
                            caseDataErr: false,
                            isLoading: false,
                            sort,
                            isTableVisible: true,
                            selectedRows: [],
                            agLoader: false,
                        }));
                        scroll(0, 0);
                    })
                    .catch((error) => {
                        this.setState({ isFirstTimeLoad: false, caseDataErr: true, isLoading: false });
                    });

            } else {
                productReportData(reportId, pageNumber, size, sort, reportSearchView, this.state.activeColumnsData, acquirerAccessList)
                    .then((apiResponse) => {
                        const formattedData = apiResponse.data.content;
                        this.setState((prevState) => ({
                            isFirstTimeLoad: false,
                            reportMetaData: reportMetaDataClone,
                            caseData: formattedData,
                            totalRecords: apiResponse.data.totalElements,
                            totalPages: apiResponse.data.totalPages,
                            currentPage: apiResponse.data.number + 1,
                            recordsShown: size,
                            isNextPage: !apiResponse.data.last,
                            caseDataErr: false,
                            isLoading: false,
                            sort,
                            isTableVisible: true,
                            selectedRows: [],
                            agLoader: false,
                        }));
                        scroll(0, 0);
                    })
                    .catch((error) => {
                        this.setState({ isFirstTimeLoad: false, caseDataErr: true, isLoading: false });
                    });
            }
        } else {
            this.setState({ isFirstTimeLoad: true, isLoading: false });
        }
    }

    getFormattedResponse(response, filter) {
        let filterValues = [];
        response.data.forEach((filterValue) => {
            if (filter === 'case_stage' || filter === 'trans_case_stage' || filter === 'case_type') {
                filterValues = filterValues.concat({
                    id: filterValue.stageId,
                    value: filterValue.stageName,
                    text: filterValue.stageName,
                });
            }
            if (filter === 'case_status' || filter === 'status') {
                filterValues = filterValues.concat({
                    id: filterValue.statusId,
                    value: filterValue.statusName,
                    text: filterValue.statusName,
                });
            }
            if (filter === 'card_brand' || filter === 'card_type' || filter === 'card_brand_code') {
                filterValues = filterValues.concat({
                    value: filterValue.cardBrandCode,
                    text: filterValue.cardBrandName,
                });
            } if (filter === 'disposition') {
                filterValues = filterValues.concat({
                    value: filterValue.dispositionCode,
                    text: filterValue.dispositionDescription,
                });
            } if (filter === 'action_code') {
                filterValues = filterValues.concat({
                    value: filterValue.actionCode,
                    text: filterValue.actionDescription,
                });
            }
            if (filter === 'merchantRegionCode') {

                filterValues = filterValues.concat({
                    value: filterValue.regionCode,
                    text: filterValue.regionCode,
                });
            }

            if (filter === 'portfolio') {
                filterValues = filterValues.concat({
                    value: filterValue.regionCode,
                    text: filterValue.regionName,
                });
            }

            if (filter === 'acquirer_name') {
                filterValues = filterValues.concat({
                    value: filterValue.acquirerCode,
                    text: filterValue.acquirerDescription,
                });
            }

            if (filter === 'merchant_case_status') {

                filterValues = filterValues.concat({
                    value: filterValue.statusName,
                    text: filterValue.statusName,
                });
            }

            if (filter === 'lateststageind') {
                filterValues = filterValues.concat({
                    id: filterValue.latesStageInd,
                    value: filterValue.latesStageInd,
                    valueLabel: filterValue.latestStagevalue,
                });
            }
            if (filter === 'corpregion' || filter === 'reason_code' || filter === 'merchant_dspn_actn' || filter === 'idr_disposition' || filter === 'idr_action_code' || filter === 'cq_sttlmnt_crrncy' || filter === 'cq_trnsctn_currency' || filter === 'cq_dspstn_ctgry') {
                filterValues = this.getFormattedResponseCorpRegion(response.data, filter);
                filterValues = this.groupByRegion(filterValues, filter)
            }

            if (filter === 'acquirer_code') {
                filterValues = filterValues.concat({
                    value: filterValue.acquirerCode,
                    text: filterValue.acquirerCode,
                });
            }
            if (filter === 'user_role') {
                filterValues = filterValues.concat({
                    value: filterValue.userRole,
                    text: filterValue.userRole,
                });
            }


          if (filter === 'merchant_adjustment') {
            filterValues = filterValues.concat({
                value: filterValue.adjustmentName,
                text: filterValue.adjustmentName,
              });
            }

            if (filter === 'idr_case_type') {
                filterValues = filterValues.concat({
                    value: filterValue.disputeStageName,
                    text: filterValue.disputeStageName,
                  });
                }

        });
        return filterValues;
    }

    getFormattedResponseCorpRegion(corpRegionResponse, filter) {
        let filterValues = [];
        if (filter === 'corpregion') {
            corpRegionResponse.forEach((filterValue) => {
                filterValues = filterValues.concat({
                    id: filterValue.regionCode,
                    value: filterValue.regionCode,
                    text: filterValue.regionCode,
                    groupName: filterValue.corp,
                    groupId: filterValue.corp,
                });
            });
        }
        else if (filter === 'reason_code') {
            corpRegionResponse.forEach((filterValue) => {
                filterValues = filterValues.concat({
                    id: filterValue.reasonCode,
                    value: filterValue.reasonCode,
                    text: `${filterValue.reasonCode} : ${filterValue.resonCodeDesc}`,
                    groupName: filterValue.cardBrandName,
                    groupId: filterValue.cardBrandCode,
                });
            });
        }
        else if (filter === 'idr_action_code') {
            corpRegionResponse.forEach((filterValue, index) => {
              filterValues = filterValues.concat({
                id: filterValue.actionCode,
                value: filterValue.actionCode,
                text: filterValue.actionDescription,
                groupName: filterValue.actionCode,
                groupId: filterValue.actionCode,
              });
            });
          } else if (filter === 'idr_disposition') {
            corpRegionResponse.forEach((filterValue, index) => {
              filterValues = filterValues.concat({
                id: filterValue.dispositionCode,
                value: filterValue.dispositionCode,
                text: filterValue.dispositionDescription,
                groupName: filterValue.dispositionCode,
                groupId: filterValue.dispositionCode,
              });
            });
          }
          else if (filter === 'merchant_dspn_actn') {
            corpRegionResponse.forEach((filterValue, index) => {
              filterValues = filterValues.concat({
                id: filterValue.merchantDispositionActionCode,
                value: filterValue.merchantDispositionActionCode,
                text: filterValue.merchantDispositionActionDescription,
                groupName: filterValue.merchantDispositionActionCode,
                groupId: filterValue.merchantDispositionActionCode,
              });
            });
          } else if (filter === 'cq_sttlmnt_crrncy' || filter === 'cq_trnsctn_currency') {
            corpRegionResponse.forEach((filterValue, index) => {
              filterValues = filterValues.concat({
                id: filterValue.currencyCode,
                value: filterValue.currencyCode,
                text: filterValue.currencyDescription,
                groupName: filterValue.currencyCode,
                groupId: filterValue.currencyCode,
              });
            });
          } else if (filter === 'cq_dspstn_ctgry') {
            corpRegionResponse.filter(obj => obj.categoryType == "disposition").forEach((filterValue, index) => {
              filterValues = filterValues.concat({
                id: filterValue.categoryCode,
                value: filterValue.categoryCode,
                text: filterValue.categoryDescription,
                groupName: filterValue.categoryType,
                groupId: filterValue.categoryType,
              });
            });
          }
        return filterValues;
    }

    groupByRegion(filterlist, filter) {
        let grp = filterlist.reduce((previous, current) => {
            let nameParts = current.groupName;
            if (!previous[nameParts]) {
                previous[nameParts] = [Object.assign({}, current)];
            } else {
                previous[nameParts].push(Object.assign({}, current));
            }
            return previous;
        }, {});
        let group = Object.keys(grp).map(key => ({ key, items: grp[key], filterName: filter, isIndeterminate: false, selected: false }));
        this.updateIsIndeterminate(group);
        return group;
    }

    updateIsIndeterminate(filterlist) {
        let that = this;
        each(filterlist, function (analyst) {
            analyst.isIndeterminate = ((!analyst.items.filter(i => {
                return i.selected
            }).length == 0) && (analyst.items.filter(i => {
                return i.selected
            }).length !== analyst.items.length)),
                analyst.selected = analyst.items.filter(i => {
                    return i.selected
                }).length == analyst.items.length
        });
    }



    fetchDynamicFilterAccToQueueId(reportId) {
        let commonArr = [];
        let acquirerAccessList = getAcquirerAccessList();
        this.setState({
            isLoading: true,
        });
        return getDynamicFitlersAccToQueueMgmtPage(reportId)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.setState({
                        activeFilters: formatActiveFilters(apiResponse.data.activeFilterElements),
                        availableFilters: formatAvailableFilters(apiResponse.data.availableFilterElements),
                        filterTypeId: apiResponse.data.filterTypeId,
                        caseDataErr: false,
                    }, () => {
                        this.fetchSavedFilterValues(this.state.filterTypeId);
                        commonArr = this.state.activeFilters.concat(this.state.availableFilters);
                        commonArr.forEach((filter) => {
                            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH'
                                || filter.elementTypeName === 'SELECT' || filter.elementTypeName === 'MULTISELECT' || filter.elementTypeName === 'TWO_MULTISELECT') {
                                    if (filter.elementId == "portfolio") {
                                        fetchFilterValuesBasedOnElementId("pr_acquirer_name").then((apiResp) => {
                                            if (apiResp.status.statusCode === 2000) {
                                                let formattedData = this.getFormattedResponse(apiResp, "acquirer_name");
                                                this.setState({
                                                    ["acquirer_name"]: formattedData,
                                                }, () => {
                                                    setTimeout(() => this.getMultiSelectFilterValues(), 3000);
                                                })
                                            }
                                        }).catch((error) => {
                                            this.setState({
                                                caseDataErr: true,
                                                isLoading: false
                                            })
                                            console.log('Error Occured while fetching filter values based on element id', error);
                                        });
                                    }
                                if (reportId === 'user_report') {
                                    if (filter.elementId === 'acquirer_code') {
                                        getFilterValuesForUserReport(filter.elementId, true)
                                            .then((response) => {
                                                if (response.status.statusCode === 2000) {
                                                    let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                    this.setState({
                                                        [filter.elementId]: formattedData,
                                                    }, () => {
                                                        setTimeout(() => this.getMultiSelectFilterValues(), 300);

                                                    })
                                                }
                                            })
                                            .catch((error) => {
                                                this.setState({
                                                    caseDataErr: true,
                                                    isLoading: false
                                                })
                                            });
                                    } else if (filter.elementId === 'user_role') {
                                        getFilterValuesBasedOnElementIdForUserReport(filter.elementId)
                                            .then((response) => {
                                                if (response.status.statusCode === 2000) {
                                                    let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                    this.setState({
                                                        [filter.elementId]: formattedData,
                                                    }, () => {
                                                        setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                                    })
                                                }
                                            })
                                            .catch((error) => {
                                                this.setState({
                                                    caseDataErr: true,
                                                    isLoading: false
                                                })
                                            });
                                    } else if (filter.elementId === 'status' || filter.elementId === 'user_type') {
                                        let formattedData = '';
                                        if (filter.elementId === 'status') {
                                            formattedData = getFormattedDimsStatus();
                                        }
                                        if (filter.elementId === 'user_type') {
                                            formattedData = getFormattedUserType();
                                        }
                                        this.setState({
                                            [filter.elementId]: formattedData,
                                        }, () => {
                                            setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                        })
                                    }
                                } else {
                                    if (filter.elementId === 'gl_status') {
                                        let formattedData = [
                                            { id: "gl_complete", value: "COMPLETE", text: "COMPLETE" },
                                            { id: "gl_void", value: "VOID", text: "VOID" },
                                            { id: "gl_pending", value: "PENDING", text: "PENDING" },
                                            { id: "gl_rejected", value: "REJECTED", text: "REJECTED" },
                                            { id: "gl_reject", value: "REJECT", text: "REJECT" },
                                            { id: "gl_supress", value: "SUPPRESS", text: "SUPPRESS" }
                                        ]
                                        this.setState({
                                            [filter.elementId]: formattedData,
                                        }, () => {
                                            setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                        })
                                    } else if (filter.elementId === 'gl_adjusted_status') {
                                        let formattedData = [
                                            { id: "gl_adjust", value: "GL-Adjust", text: "GL-Adjust" },
                                            { id: "gl_not_adjust", value: "GL-Not Adjust", text: "GL-Not Adjust" },
                                        ]
                                        this.setState({
                                            [filter.elementId]: formattedData,
                                        }, () => {
                                            setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                        })
                                    } else if (filter.elementId === 'cq_dspstn_ctgry') {
                                        getQueueLabels(true).then((response) => {
                                            if (response.status.statusCode === 2000) {
                                                let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                this.setState({
                                                    [filter.elementId]: formattedData,
                                                }, () => {
                                                    setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                                })
                                            }
                                        })
                                            .catch((error) => {
                                                this.setState({
                                                    isLoading: false,
                                                })
                                                console.log('Error Occured while fetching queue labels', error);
                                            });
                                    } else if (acquirerAccessList != null) {
                                        getFilterValuesBasedOnElementIdWithAcquirer(filter.elementId, acquirerAccessList)
                                            .then((response) => {
                                                if (response.status.statusCode === 2000) {
                                                    let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                    this.setState({
                                                        [filter.elementId]: formattedData,
                                                    }, () => {
                                                        setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                                    })
                                                }
                                            })
                                            .catch((error) => {
                                                this.setState({
                                                    caseDataErr: true,
                                                    isLoading: false
                                                })
                                            });
                                    } else {
                                        getFilterValuesBasedOnElementId(filter.elementId)
                                            .then((response) => {
                                                if (response.status.statusCode === 2000) {
                                                    let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                    this.setState({
                                                        [filter.elementId]: formattedData,
                                                    }, () => {
                                                        setTimeout(() => this.getMultiSelectFilterValues(), 300);

                                                    })
                                                }
                                            })
                                            .catch((error) => {
                                                this.setState({
                                                    caseDataErr: true,
                                                    isLoading: false
                                                })
                                            });
                                    }
                                }
                            }
                        })
                    });
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
            })
    }

    getMultiSelectFilterValues() {
        let activeFilters = [];
        activeFilters = this.state.activeFilters.map((filter) => {
            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH'
                || filter.elementTypeName === 'SELECT' || filter.elementTypeName === 'MULTISELECT' || filter.elementTypeName === 'TWO_MULTISELECT') {
                if (filter.elementId == "portfolio") {
                    return {
                        ...filter,
                        filterValues: this.state[filter.elementId],
                        filterValuesSecondField: this.state["acquirer_name"],
                        elementLabelSecond: "Acquirer Name",
                        elementPlaceHolder: "Merchant Zone",
                    }
                } else {
                    return {
                        ...filter,
                        filterValues: this.state[filter.elementId]
                    }
                }
            } else {
                return filter;
            }
        })
        this.setState({
            formattedFilters: activeFilters,
            isFormattedFiltersSet: true
        });
    }

    saveActiveDynamicFilters(activeFilters, newFilterValues, corp, regionCode, corpRegion) {
        let activeFilterValues = newFilterValues;

        splitMergedElementIdsFilterValues(activeFilterValues, activeFilters, corp, regionCode).filter(data => data.elementValue !== '');


        return postActiveDynamicFilters(this.state.filterTypeId, activeFilters)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.setState((prevState) => ({
                        reportSearchView: {
                            filterTypeId: prevState.filterTypeId,
                            searchFilterInputElements: splitMergedElementIdsFilterValues(newFilterValues, activeFilters, corp, regionCode, prevState.filterTypeId).filter(data => data.elementValue !== ''),
                        },
                    }), () => {
                        this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, 25, this.state.sort, this.state.reportSearchView);
                    })
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true });
                console.log('Error Occured while saving dynamic active filters', error);
            })
    }

    pageHandler = (newPage, newPerPage) => {

        this.setState({
            isLoading: true,
        });

        const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
        if (newPage) {
            this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, newPage - 1, pageSize, this.state.sort, this.state.reportSearchView);
        }
    }

    onSearchChange = (filterText) => {
        this.setState({ filterText });
    }

    handleSort = (key, sortArr) => {


        this.setState({
            currentPage: 1,
            agLoader: true,
        });
        this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, this.state.recordsShown, sortArr, this.state.reportSearchView);
    }

    toggleFileExport = () => {
        this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible, setSize: false });
    }

    onRowClick = (event, sequenceKey) => {
        if ((!event.target.id &&
            !event.target.classList.contains('gd-row-actions') &&
            !event.target.classList.contains('dropdown-menu-trigger')) ||
            event.target.parentNode.classList.contains('primary')) {
            alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
        }
    }

    rowActionClick(selectedKeyIndex, key) {
        this.setState({
            selectedKeyIndex,
        });

        if (key === 'DETAIL_DRAWER') {
            this.setState({
                drawerOpen: true,
                selectedKeyIndex,
            });
            this.props.setDrawerOpenFlag(true);
        }
        if (key === 'STAGE_CLOSE') {
            return closeCaseStage(this.state.caseData[selectedKeyIndex].caseStageId)
                .then((apiResponse) => {
                    if (apiResponse.status.statusCode === 2000) {
                        this.setState({ isStageClosed: true, caseNumber: this.state.caseData[selectedKeyIndex].caseNumber, caseType: this.state.caseData[selectedKeyIndex].disputeStageName });
                    }
                })
                .catch((error) => {
                    this.setState({ caseDataErr: true, isLoading: false });
                    console.log('Error Occured while deleting case stage', error);
                })
        }
        if (key === "OPEN_CASE_IN_TAB") {
            gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
        }
    }

    gotoCaseLandingPage(selectedKeyIndex) {
        this.props.history.push({
            state: {
                data: this.state.caseData[selectedKeyIndex],
                prevPath: this.props.location.pathname,
            },
            pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
        });
    }

    saveCurrentlyVisibleColumns(columns) {

        let pageId = this.state.pageListId;

        this.setState({
            dataColumns: columns,
        });

        const activeDataColumns = [];
        columns.forEach((column) => {
            if (column.displayType !== 'ICON') {
                const activeColumn = {
                    columnId: column.columnId,
                    displayOrder: column.displayOrder,
                    columnKey: column.columnKey,
                };
                activeDataColumns.push(activeColumn);
            }
        });

        this.postActiveFilters(activeDataColumns, pageId);
    }

    postActiveFilters(columns, pageId) {
        if (pageId === 'bre_summary_rpt') {
            this.setState({
                isLoading: true,
                activeColumnsData: columns,
                isApplySummary: true,
            });
        }
        if (pageId === 'dispute_product_rpt') {
            this.setState({
                isLoading: true,
                activeColumnsData: columns,
                isApplySummary: true,
            });
        }

        if (pageId === 'merchant_gl_rpt') {
            this.setState({
                isLoading: true,
                activeColumnsData: columns,
                isApplySummary: true,
            });
        }
        if (pageId === 'user_report') {
            this.setState({
                isLoading: true,
                activeColumnsData: columns,
                isApplySummary: false,
            });
        }
        
        if (pageId !== 'bre_summary_rpt') {
            this.setState({
                isApplyColumnManager: true,
            });
        }
        return postActiveFilters(pageId, columns)
            .then(() => {
                this.props.fetchDataColumns(pageId);
                this.setState({
                    caseDataErr: false,
                });
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('Error Occured while saving active data columns', error);
            });
    }

    toggleFilterPane() {
        document.body.classList.add('instant-header');
        scroll(0, 0);
        this.setState(
            {
                isVisible: !this.state.isVisible,
                isVisibleNew: !this.state.isVisibleNew,
            },
        );
    }

    exportAction = (fileObject) => {
        this.toggleFileExport();
        let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
        let fileType = fileObject.fileType.value;
        let fileName = fileObject.fileName;
        this.state.totalRecords > 25000 ?
            this.setState({
                setSize: true,
            })
            :
            this.exportFile(fileName, fileType, isAllColumns);
    }

    exportFile(fileName, fileType, isAllColumns) {
        let sortKeyString = [];
        let sortOrderString = [];
        if (this.state.reportId !== '8') {
            this.state.sort.forEach((element) => {
                sortKeyString.push(element.key);
                sortOrderString.push(element.order ? 'ASC' : 'DESC');
            });
            let acquirerAccessList = getAcquirerAccessList();
            let reportExportData = {
                fileType: fileType,
                isAllColumns: isAllColumns,
                searchFilterInput: {
                    filterTypeId: this.state.filterTypeId,
                    searchFilterInputElements: this.state.reportSearchView.searchFilterInputElements,
                    orderByProperties: sortKeyString,
                    propertyDirections: sortOrderString
                },
                summaryReportColumnKey: this.state.activeColumnsData,
                pageId: this.state.pageListId,
                reportId: this.state.reportId,
                acquirerAccessList: acquirerAccessList,
            }
            this.setState({ exporting: true });
            exportReportData(reportExportData).then((response) => {
                let limitExceedsCheck = response.split(/\n/);
                if ((limitExceedsCheck.length - 1) > 25000) {
                    this.checkSize();
                } else {
                    this.downloadFile(fileName, fileType, response);
                }
                this.setState({ exporting: false });
            })
                .catch((error) => {
                    this.setState({ exporting: false });
                    console.log('Error Occured while exporting the case', error);
                });
        } else {
            let objField = {};
            let fieldArr = [];
            let filterarr = [];
            this.state.sort.forEach((element) => {
                objField["fieldId"] = getFieldName(element),
                    objField["orderByProperty"] = element.order ? 'ASC' : 'DESC'
            });
            fieldArr.push(objField);
            
            let acquirerAccessList = getAcquirerAccessList();
           
            
              if (this.state.reportSearchView.searchFilterInputElements.length > 0) {
                this.state.reportSearchView.searchFilterInputElements.forEach((col) => {
                  filterarr.push({ columnKey: getcolumnKey(col.elementId), columnValue: col.elementValue });
                });
            
              }
            let reportExportData = {
                fileType: fileType,
                isAllColumns: isAllColumns,
                searchFilterElements: filterarr,
                summaryReportElements: this.state.activeColumnsData,
                pageId: this.state.pageListId,
                reportId: this.state.reportId,
                acquirerAccessList: acquirerAccessList,
                sortingElement: fieldArr,
                pageNumber: 0,
                size: 25
            }
            this.setState({ exporting: true });
            exportUserManagerReportData(reportExportData).then((response) => {
                let limitExceedsCheck = response.split(/\n/);
                if ((limitExceedsCheck.length - 1) > 25000) {
                    this.checkSize();
                } else {
                    this.downloadFile(fileName, fileType, response);
                }
                this.setState({ exporting: false });
            })
                .catch((error) => {
                    this.setState({ exporting: false });
                    console.log('Error Occured while exporting the case', error);
                });
        }

    }
    checkSize() {
        this.props.setNotification([{
            title: 'Error Occurred',
            descriptionStyle: "color: 'grey'",
            description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
            type: 'danger',
            noActions: true,
            cancelOnly: true,
            closeNotification: () => this.props.closeNotification(),
        }]);
        this.setState({
            setSize: false,
        })
    }
    downloadFile(fileName, fileType, fileContent) {
        let type = fileType == 'csv' ? 'text/csv' : 'application/pdf';
        var blob = new Blob([fileContent], { type: type });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, fileName + '.' + fileType)
        } else {
            var element = document.createElement('a');
            element.href = window.URL.createObjectURL(blob);
            element.download = fileName + '.' + fileType;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }


    onCheckboxClick(key) {
        this.props.closeNotification();
        if (Array.isArray(key)) {
            this.setState({
                selectedRows: key,
            });
        } else {
            let presenceIndex = this.state.selectedRows.findIndex(row => row === key);
            // Add to selected items or remove if already present.
            this.setState({
                selectedRows: presenceIndex === -1 ? this.state.selectedRows.concat(key) : this.state.selectedRows.filter(row => row !== key),
            });
        }
    }

    handleCaseSelectionValidation() {
        this.props.setNotification([{
            title: 'Please select at least one case to assign',
            descriptionStyle: "color: 'grey'",
            type: 'danger',
            cancelButtonText: 'CLOSE',
            cancelOnly: true,
            closeNotification: () => this.props.closeNotification(),
            valueStyle: "color: 'black'",
        }]);
    }

    goToPreviousRecord = () => {
        this.state.selectedKeyIndex > 0 && this.setState((prevState) => ({
            selectedKeyIndex: prevState.selectedKeyIndex - 1,
        }));
    };

    goToNextRecord = () => {
        this.state.selectedKeyIndex + 1 < this.state.caseData.length && this.setState((prevState) => ({
            selectedKeyIndex: prevState.selectedKeyIndex + 1,
        }));
    };

    toggleDrawer = () => {
        document.body.style.overflow = 'visible';
        this.props.setDrawerOpenFlag(false);
        this.setState({
            drawerOpen: !this.state.drawerOpen,
        });
    }

    formatRequestBody(selectedCases, userId) {
        return selectedCases.map(selectedCaseStageId => {
            return {
                userID: userId,
                caseStageID: `${selectedCaseStageId}`,
                undo: false,
            }
        });
    }

    onKeyDown(event) {
        if (event.keyCode == 27) {
            this.setState({
                displayFloatingPanel: false,
                selectedRows: [],
            });
            console.log('Esc key pressed.');
        }
    }

    closeFilterPane = () => {
        scroll(0, 0);
        this.setState({ isVisible: false, isVisibleNew: false, });
    }

    resetScrollPos() {
        this.setState({
            scrollPos: 0,
        });
    }

    applyFilters(newValues, filterList, corp, region, corpRegion) {
        this.setState({
            isLoading: true,
        })
        const newFilterValues = convertJsonObjectToArray(newValues, filterList);
        let element;
        if(newFilterValues.length===1){
          element= Object.keys(newValues).map((key) => {return key;});
        }
      
        if (newFilterValues.length === 0 || (newFilterValues.length === 1 && element[0] === 'acquirerCode')) {
            this.setState({
                isRequiredFilter: true,
                isVisible: true,
                isVisibleNew: true,
                isLoading: false,
            })
        }
        else {
            this.setState({
                activeFiltersValues: mapActiveFilters(newFilterValues, filterList),
                isVisible: false,
                isVisibleNew: false,
                corp:corp,
                region:region,
                corpRegion: corpRegion,
                enableSaveFilter: true,
                applyAuto: false,
            })

            const newActiveFilters = mapActiveFilters(newFilterValues, filterList);
            let filterParams = this.prepareResponseForSearchApi(newActiveFilters);
            let accountNumberFilter = filterParams.find(data => data.fieldId == 'full_card_number');
            if (accountNumberFilter) {
                this.getTokenFromCardNumber(accountNumberFilter.fieldValues1, filterList);
            }
            else {
                this.saveActiveDynamicFilters(splitMergedElementIdsFilters(filterList), mapActiveFilters(newFilterValues, filterList), corp, region, corpRegion);
                this.getMultiSelectFilterValues();
            }
        }
    }

    prepareResponseForSearchApi(newActiveFilters) {
        let filters = [];
        newActiveFilters.forEach((newActiveFilter) => {
            const filter = {
                fieldId: newActiveFilter.id,
                fieldValues1: this.setFieldValue(newActiveFilter),
                fieldvalue2: (newActiveFilter.v2 && newActiveFilter.name.includes('Date')) ? this.changeDateFormat(newActiveFilter.v2, 'YYYY/MM/DD') : newActiveFilter.v2,
            };
            if (newActiveFilter.v1 && newActiveFilter.v1.length != 0) { filters.push(filter); }
            if (newActiveFilter.id == 'case_mask_acc_number' && newActiveFilter.v1 == undefined) {
                filter.fieldValues1 = [""];
                filters.push(filter);
            }
        });
        return filters;
    }

    changeDateFormat(filterValue, dateFormat) {
        return (filterValue)
            ?
            (
                (filterValue.split('/').length > 1 || filterValue.split('-').length > 1)
                    ?
                    moment(filterValue).format(dateFormat)
                    :
                    filterValue
            )
            :
            '';
    }

    setFieldValue(newActiveFilter) {
        if (newActiveFilter.name.includes('Date') && newActiveFilter.v1.split('/').length > 1) { return this.changeDateFormat(newActiveFilter.v1, 'YYYY/MM/DD').split(); }
        return newActiveFilter.v1 != undefined && !isObject(newActiveFilter.v1) ? newActiveFilter.v1.split() : newActiveFilter.v1;
    }

    getTokenFromCardNumber(cardNumber, filters) {
        let elementValues = [];
        return getToken(cardNumber)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    const updatedFilters = filters.map(function (obj) {
                        if (obj.elementId == 'full_card_number') {
                            elementValues = [{
                                v1: apiResponse.data.GlobalToken,
                                id: "full_card_number",
                                elementCategoryName: "EXACT",
                                elementTypeName: "STRING"
                            }];
                            return { ...obj };
                        }
                        return { ...obj };
                    });
                    this.setState({
                        activeFiltersValues: mapActiveFilters(elementValues, updatedFilters),
                    })
                    this.saveActiveDynamicFilters(splitMergedElementIdsFilters(updatedFilters));
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('Error Occured while tokenizing Card Number', error);
            });

    }

    updateColumnsInfo(columns) {
        scroll(0, 0);
        this.setState({
            activeFilters: columns.activeColumns,
            availableFilters: columns.availableColumns,
        })
        if (columns.identifier) {
            const newFilterValues = convertJsonObjectToArray(columns.currentValues, columns.filterList);
            this.setState(() => ({
                activeFiltersValues: mapActiveFilters(newFilterValues.filter(data => data && data.id !== columns.identifier), columns.filterList)
            }))
        }

        const finalFilterElements = columns.activeColumns.map((filterElement) => {
            if (filterElement.elementTypeName === 'DYNAMIC_MULTISELECT' || filterElement.elementTypeName === 'GROUP_SEARCH'
                || filterElement.elementTypeName === 'SELECT' || filterElement.elementTypeName === 'MULTISELECT' || filterElement.elementTypeName === 'TWO_MULTISELECT') {
                if (filterElement.elementId == "portfolio") {
                    return {
                        ...filterElement,
                        filterValues: this.state[filterElement.elementId],
                        filterValuesSecondField: this.state["acquirer_name"],
                        elementLabelSecond: "Acquirer Name",
                        elementPlaceHolder: "Merchant Zone",
                    }
                } else {
                    return {
                        ...filterElement,
                        filterValues: this.state[filterElement.elementId],
                    }
                }
            } else {
                return filterElement;
            }
        });
        this.setState({
            formattedFilters: finalFilterElements,
            dynamicFilterFlag: true,
            isFormattedFiltersSet: true
        });

    }

    closeBanner() {
        this.setState({
            isRequiredFilter: false,
        })
    }

    closeStageBanner() {
        this.setState({
            isRequiredFilter: false,
            isStageClosed: false,
        })
        this.getDataForDetailReport(false, this.state.reportId, this.state.reportName, 0, this.state.recordsShown, this.state.sort, this.state.reportSearchView);
    }

    toggleDropdown(event) {
        event.persist();
        const id = event.currentTarget.id;
        const dropdownToggled = this.state.dropdownToggled;
        dropdownToggled[`${id}`] = !dropdownToggled[`${id}`];
        this.setState({ dropdownToggled });
    }

    deactivateFilter(id) {
        const newFilters = this.state.activeFiltersValues.filter((filter) => {
            return filter.id !== id;
        });
        this.setState(
            {
                activeFiltersValues: mapActiveFilters(newFilters, this.state.activeFilters),
                savedFilters: mapSavedFilters(this.state.savedFilters, newFilters),
            }
        );
    }

    clearAllFilters() {
        this.clearGroupSearchValue();
        this.setState(
            {
                activeFiltersValues: [],
                savedFilters: mapSavedFilters(this.state.savedFilters),


            }
        );
    }
    clearGroupSearchValue() {
        this.state.formattedFilters.map((element) => {
            if (element.elementTypeName === 'GROUP_SEARCH') {
                for (let i = 0; i < element.filterValues.length; i++) {
                    element.filterValues[i].selected = false;
                    let items = element.filterValues[i].items;
                    for (let j = 0; j < items.length; j++) {
                        items[j].selected = false;
                    }
                }
            }
        })
    }
    saveFilterName() {
        const updateIndex = this.state.savedFilters.findIndex((caseObject) => {
            return caseObject.filterName === this.state.filterName;
        });
        if (updateIndex == -1) {
            return postActiveFilterValues(this.state.filterTypeId, splitMergedElementIdsFilterValuesSaveFilter(this.state.activeFiltersValues, this.state.activeFilters, this.state.corpRegion), this.state.filterName)
                .then((apiResponse) => {
                    if (apiResponse.status.statusCode === 2000) {
                        this.setState({ filterName: '', saveFilterToggled: false });
                        this.fetchSavedFilterValues(this.state.filterTypeId);
                    }
                })
                .catch((error) => {
                    this.setState({ caseDataErr: true, isLoading: false, filterName: '' });
                    console.log('Error Occured while saving active filter values with name', error);
                })
        } else {
            this.setState({
                saveFilterFail: true,
                filterName: '',
            });
        }

    }

    fetchSavedFilterValues(filterTypeId) {
        getSavedFiltersBasedOnSearchTypeId(filterTypeId)
            .then((apiResponse) => {
                this.setState({
                    savedFilters: mergeSavedElementIdsForRangeElements(apiResponse.data),
                    noSavedFilters: apiResponse.data.length > 0 ? false : true,
                    tempSavedFilters: apiResponse.data,
                })
            })
            .catch((error) => {
                this.setState({ noSavedFilters: true });
                console.log('Error Occured while fetching active filter values', error);
            })
    }

    toggleSavedFilter = () => {
        this.setState({ saveFilterToggled: !this.state.saveFilterToggled });
    };

    onChange(event) {
        if (event.target) {
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    updateSearchField(value) {
        const lowercaseSearchTerm =
            value && value.toLowerCase && value.toLowerCase();
        const filteredFilters = this.state.tempSavedFilters.filter((filter) => {
            // the most redundant, yet appropriate name ever
            const lowercaseFilterName = filter.filterName.toLowerCase();
            return lowercaseFilterName.includes(lowercaseSearchTerm);
        });
        this.setState({
            currentSearchTerm: value,
            savedFilters: mergeSavedElementIdsForRangeElements(filteredFilters),
        });
    }

    removeSavedFilter(id) {
        const newFilters = this.state.savedFilters.filter((filter) => {
            return filter.id !== id;
        });
        this.setState(
            {
                savedFilters: newFilters,
                isOpenSavedFilterDropdown: false,
            },
            () => {
                const body = document.querySelector('body');
                const e = document.createEvent('MouseEvents');
                e.initEvent('mousedown', true, true);
                body.dispatchEvent(e);
            },
        );

        return deleteSavedFilter(id)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.fetchSavedFilterValues(this.state.filterTypeId);
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true });
                console.log('error received while deleting filters based on filterId', error);
            });
    }

    setSavedFilterAsActive(id) {
        let index = -1;
        const newFilters = this.state.savedFilters.map((filter) => {
            index++;
            return Object.assign({}, filter, {
                isActive: filter.filterId === id,
            });
        });
        this.setState(
            {
                savedFilters: newFilters,
                isOpenSavedFilterDropdown: false,
            },
            () => {
                const filterSetToUse = this.state.savedFilters.find(
                    (set) => set.isActive,
                );
                this.applySavedFilterSet(filterSetToUse);
            },
        );
    }

    applySavedFilterSet(filterSetToUse) {
        let availFilters = []
        const newActiveFiltersStr = filterSetToUse.filterParams;
        const newActiveFilters = formatActiveFilters(filterSetToUse.activeFilters);
        const newActiveFiltersValues = mapActiveFilters(newActiveFiltersStr, newActiveFilters);

        // setting available filters while applying saved filters DE82718
        if (this.state.activeFilters !== undefined && this.state.activeFilters.length > 0) {
            availFilters = removeFilterActionSavedFilter(this.state.availableFilters, this.state.activeFilters, filterSetToUse.filterParams)
            this.setState({
                availableFilters: availFilters
            })
        }

        let dynamicFilters = newActiveFilters.map((filter) => {
            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' ||
                filter.elementTypeName === 'SELECT' || filter.elementTypeName === 'MULTISELECT' || filter.elementTypeName === 'TWO_MULTISELECT') {
                if (filter.elementId == "portfolio") {
                    return {
                        ...filter,
                        filterValues: this.state[filter.elementId],
                        filterValuesSecondField: this.state["acquirer_name"],
                        elementLabelSecond: "Acquirer Name",
                        elementPlaceHolder: "Merchant Zone",
                    }
                } else {
                    return {
                        ...filter,
                        filterValues: this.state[filter.elementId],
                    }
                }
            } else {
                return filter;
            }
        });
        newActiveFiltersValues.map((filterValue) => {
            if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` !== 'corpregion') {
                filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
                let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
                if (dynamicFilterIndex != -1) {
                    dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
                        groupFilterValue.items.map(groupFilterVal => {
                            if( filterValue.id == "reason_code" && filterValue.v1[0] && filterValue.v1[0].includes('-')  && !groupFilterVal.id.includes('-') ){
                                let value = groupFilterVal.id + "-" + groupFilterVal.groupId
                                groupFilterVal.selected = filterValue.v1.find((e) => e==value) ? true : false 
                            } else if (filterValue.v1.findIndex(v1Val => v1Val == groupFilterVal.id) == -1) {
                                groupFilterVal.selected = false;
                            } else {
                                groupFilterVal.selected = true;
                            }
                        })
                        let actualDataCnt = groupFilterValue.items.length;
                        let selectedDataCnt = groupFilterValue.items.filter(obj => obj.selected === true).length;
                        if (selectedDataCnt != 0 && actualDataCnt == selectedDataCnt) {
                            groupFilterValue.selected = true;
                        } else if (selectedDataCnt != 0 && actualDataCnt > selectedDataCnt) {
                            groupFilterValue.isIndeterminate = true;
                        }
                    })
                }
            } else if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` === 'corpregion') {
                filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
                let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
                if (dynamicFilterIndex != -1) {
                    dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
                        groupFilterValue.items.map(groupFilterVal => {
                            for (let index = 0; index < filterValue.value.length; index++) {
                                let region = ''
                                let corp = ''
                                region = JSON.parse(JSON.stringify(filterValue.value[index]))["regionCode"]
                                corp = JSON.parse(JSON.stringify(filterValue.value[index]))["corp"]
                                if (region == groupFilterVal.id && corp == groupFilterVal.groupId) {
                                    groupFilterVal.selected = true
                                    break;
                                } else {
                                    groupFilterVal.selected = false
                                }
                            }
                        })
                    })
                }
            }
        });
        let corpregionfilter = "";
        for (let j = 0; j < dynamicFilters.length; j++) {
            if (dynamicFilters[j].elementId == 'corpregion') {
                corpregionfilter = dynamicFilters[j];
            }
        }
        if (corpregionfilter != "") {
            for (let i = 0; i < this.state.corpregion.length; i++) {
                let actualDataCnt = this.state.corpregion[i].items.length;
                let selectedDataCnt = corpregionfilter.filterValues[i].items.filter(obj => obj.selected === true).length;
                if (selectedDataCnt != 0 && actualDataCnt == selectedDataCnt) {
                    corpregionfilter.filterValues[i].selected = true;
                } else if (selectedDataCnt != 0 && actualDataCnt > selectedDataCnt) {
                    corpregionfilter.filterValues[i].isIndeterminate = true;
                }
            }
        }

        this.setState({
            formattedFilters: dynamicFilters,
            activeFiltersValues: newActiveFiltersValues,
            activeFilters: newActiveFilters,
            isVisible: true,
            isVisibleNew: true,
            applyAuto: true,
            isFormattedFiltersSet: true
        }, () => {
            const body = document.querySelector('body');
            const e = document.createEvent('MouseEvents');
            e.initEvent('mousedown', true, true);
            body.dispatchEvent(e);
        });
    
    }

    closeSaveFilterFailBanner() {
        this.setState({
            saveFilterFail: false,
        });
    }

    routeToPreviousPage() {
        this.props.history.push({
            pathname: (this.state.reportId === '7' || this.state.reportId === '8' || this.state.reportId === '9') ? '/reports/productreport' : '/reports/operations',
        });
    }

    fullPageRefresh = () => {
        window.location.reload();
    }

    disableSaveButton = () => {
        this.setState({
            enableSaveFilter: false,
        });
    }
    
    render() {
        window.document.title = this.state.reportName;
        const reportDataConfig = this.state.reportMetaData;
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const isChecked = this.state.selectedRows.length > 0 ? true : false;
        const filterdRecords = this.state.caseData.filter(dataRow => !this.state.casesToHide.includes(dataRow.caseStageId));
        const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
            'is-disabled': false,
        });
        /*  if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.canViewAll === true) { */
        return (
            <section>
                <FloatingPanel
                    count={this.state.selectedRows.length}
                    text={this.state.dragOvertText}
                />
                <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : "main-content--header reports-container--header"} style={{ zIndex: 3 }}>
                    {this.state.setSize == true && this.checkSize()}
                    <div className="flex-left">
                        <h1>{this.state.reportName}</h1>
                    </div>
                    <div className="flex-right" style={{ paddingRight: 13 }}>
                        <div className="gd-report-runner__actions">
                            <div className="gd-report-runner__actions-filters">
                                <a data-tip data-for="filtering" data-offset="{'right': 320}">
                                    <GDActiveFiltersDropdown
                                        activeFilters={this.state.activeFiltersValues}
                                        dateFormat={this.state.dateFormat}
                                        deactivateFilter={this.deactivateFilter}
                                        dropdownToggled={this.state.dropdownToggled}
                                        filterDefinitions={this.state.activeFilters}
                                        toggleDropdown={this.toggleDropdown}
                                        translations={getTranslations()}
                                        showDynamicFilter={true}
                                    />
                                </a>
                            </div>
                            {this.state.activeFiltersValues.length > 0 && (
                                <div className="gd-report-runner__actions-clear">
                                    <LinkInlineButton action={this.fullPageRefresh}>
                                        Clear All
                  </LinkInlineButton>
                                    <span>&nbsp;|&nbsp;</span>
                                </div>
                            )}
                            <div className="gd-report-runner__actions-save">
                                <LinkInlineButton
                                    action={this.toggleSavedFilter}
                                    disabled={(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) ? !this.state.enableSaveFilter : this.props.isProvidingSupport}
                                >
                                    Save
                </LinkInlineButton>
                                {this.state.saveFilterToggled &&
                                    <GDNewFilterDropdown
                                        toggleDropdown={this.toggleSavedFilter}
                                        onChange={this.onChange}
                                        saveFilterName={this.saveFilterName}
                                        translations={getTranslations()}
                                        value={this.state.filterName}
                                    />
                                }
                            </div>
                        </div>
                        <div className="gd-filters-dropdown__wrapper gd-report-runner__icon-popup-wrapper">
                            <OptionBoxPopup
                                icon={StarIcon}
                                id="Transaction Search_OptionBoxPopup"
                                triggerText=""
                                showHelpText={getTranslations().savedFilters}
                            >
                                <GDSavedFiltersDropdown
                                    noSavedFilters={this.state.noSavedFilters}
                                    onChange={this.updateSearchField}
                                    removeSavedFilter={this.removeSavedFilter}
                                    savedFilters={this.state.savedFilters}
                                    searchTerm={this.state.currentSearchTerm}
                                    setSavedFilterAsActive={this.setSavedFilterAsActive}
                                    translations={getTranslations()}
                                />
                            </OptionBoxPopup>
                        </div>
                        <div
                            role="button"
                            tabIndex={0}
                            id="Settled Batches_filter_btn"
                            className={filterPaneTriggerClasses}
                            onClick={this.toggleFilterPane}
                            aria-expanded={(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) ? this.state.isVisibleNew : this.state.isVisible}
                        >
                            <span className="gd-report-runner__filter-toggle">Filter</span>
                        </div>
                    </div>
                </div>

                {( this.state.activeFilters.length > 0
                    ? (this.state.formattedFilters.length > 0 ? false : true ) 
                    : false
                 ) && <div className="ball-sync-loader loader" style={{ backgroundColor: 'white' }}><BVLoader20 /></div>
                }

                {( this.state.activeFilters.length > 0
                    ? (this.state.formattedFilters.length > 0 ? true : false ) 
                    : true
                 ) && (this.state.isFormattedFiltersSet)
                 && <div className="main-content--wrapper" style={{ width: '100%' }}>
                    <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
                        <FilterPane 
                            applyFilters={this.applyFilters}
                            closeFilterPane={this.closeFilterPane}
                            currentValues={this.state.activeFiltersValues}
                            dateFormat={this.state.dateFormat}
                            filterList={this.state.formattedFilters}
                            isVisible={(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) ? this.state.isVisibleNew : this.state.isVisible}
                            translations={getTranslations()}
                            reportName="Received Disputes_filterPane"
                            extraClass="some-class"
                            activeFilters={this.state.activeFilters}
                            resetScrollPos={this.resetScrollPos}
                            showDynamicFilter={true}
                            availableFilters={this.state.availableFilters}
                            updateColumnsInfo={this.updateColumnsInfo}
                            updateIsIndeterminate={this.updateIsIndeterminate}
                            clearAllFilters={this.clearAllFilters}
                            reportId={this.state.reportId}
                            isInvBreReport={(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) && true }
                            applyAuto= {(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) && this.state.applyAuto}
                            disableSaveButton= {(this.state.reportId == 1 || this.state.reportId == 2 || this.state.reportId == 3) ? this.disableSaveButton : ()=>{}}
                        />
                    </div>
                    {this.state.caseDataErr && !this.state.isLoading && !this.state.isFirstTimeLoad && (
                        <div
                            className="queue-mgmt-empty-state"
                        >
                            <EmptyState
                                translations={{
                                    emptyStateHeading: 'Data not available.',
                                    emptyStateDescription: 'Please try again later.'
                                }}
                            />
                        </div>
                    )
                    }
                    {this.state.isFirstTimeLoad && !this.state.isLoading && (
                        <div className="first-load-state">
                            <div>
                                <ExclamationIcon />
                            </div>
                            <div className="first-load-state__title">
                                No Data Generated
                            </div>
                            <div className="first-load-state__description">
                                To run this report, please select and apply a filter.
                            </div>
                        </div>
                    )}

                    {this.state.isRequiredFilter &&
                    <ImagePortal>
                        <ResponseBanner
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title="Validation Error"
                            description="Atleast one field is required for search"
                            type="danger"
                            onClose={this.closeBanner}
                            cancelButtonText="DISMISS"
                            primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                            primaryButtonAction={this.closeBanner}
                        />
                        </ImagePortal>
                    }

                    {this.state.isStageClosed &&
                    <ImagePortal>
                        <ResponseBanner
                            titleStyle={{ color: 'light-green' }}
                            descriptionStyle={{ color: 'grey' }}
                            valueStyle={{ color: 'black' }}
                            title={`${this.state.caseNumber} : ${this.state.caseType}`}
                            description="Stage has been successfully closed."
                            type="success"
                            successOnly={true}
                            onClose={this.closeStageBanner}
                            primaryButtonText="Ok, Great!"
                            primaryButtonAction={this.closeStageBanner}
                        />
                        </ImagePortal>
                    }

                    {this.state.isLoading && <div className="ball-sync-loader loader" style={{ backgroundColor: 'white' }}><BVLoader20 /></div>}
                    <div className="queue-mngmnt-content--wrapper">
                        {this.state.saveFilterFail && <div>
                            <ImagePortal>
                            <ResponseBanner
                                titleStyle={{ color: 'light-green' }}
                                descriptionStyle={{ color: 'grey' }}
                                valueStyle={{ color: 'black' }}
                                title="Error Occured"
                                description="Filter name already present. Please enter unique filter name"
                                type="danger"
                                onClose={this.closeSaveFilterFailBanner}
                                cancelButtonText="DISMISS"
                                primaryButtonActionValue=""
                                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                                primaryButtonAction={this.closeSaveFilterFailBanner}
                            />
                            </ImagePortal>
                        </div>}

                        {reportDataConfig.displayType == 'gdTable' && !this.state.isLoading && !this.state.caseDataErr && !this.state.isFirstTimeLoad && <div className="report-landing-content" id="reportLandingTable" ref={((ref) => (this.gdTable = ref))}>
                            <GDTable
                                className={this.state.drawerOpen ? ' opacity' : 'reportLandingTable'}
                                // className="queueLandingTable"
                                exportFileName={this.state.reportName}
                                report={this.state.reportMetaData}
                                tableName={this.state.tableName}
                                data={filterdRecords}
                                dateFormat={this.state.dateFormat}
                                totalPages={this.state.totalPages}
                                totalRecords={this.state.totalRecords}
                                recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                                currentPage={this.state.currentPage}
                                recordsShown={this.state.recordsShown}
                                sort={this.state.sort}
                                handleSort={this.handleSort}
                                pageHandler={this.pageHandler}
                                translations={getTranslations()}
                                filterText={this.state.filterText}
                                onRowClick={this.onRowClick}
                                isPagable={reportDataConfig.isPagable}
                                onSearchChange={this.onSearchChange}
                                isNextPage={this.state.isNextPage}
                                exporting={this.state.exporting}
                                exportAction={this.exportAction}
                                filterExportIsVisible={this.state.filterExportIsVisible}
                                toggleFileExport={this.toggleFileExport}
                                actionButtonText="Actions"
                                rowActionClick={this.rowActionClick}
                                isLoading={this.state.isLoading}
                                saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                                addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
                                titleRequired={reportDataConfig.titleRequired}
                                isCheckboxOnRowRequired={reportDataConfig.isCheckboxOnRowRequired}
                                recordCountRequired={reportDataConfig.recordCountRequired}
                                isFetchingData={false}
                                headerCountData={this.state.headerCountData}
                                onCheckboxClick={this.onCheckboxClick}
                                selectedRows={this.state.selectedRows}
                                dragOvertText={this.state.dragOvertText}
                                openBoxDropDownStyle={{
                                    width: 150,
                                    marginLeft: -53,
                                    fontSize: 'initial',
                                }}
                                routeToPreviousPage={this.routeToPreviousPage}
                                showBackToReport={true}
                                isReport={true}
                                agLoader={this.state.agLoader}
                                isAgGrid={true}
                                pageListId={this.state.pageListId}
                                actionWidth={this.state.actionBtnWidth}
                            />

                        </div>}
                    </div>
                    {this.state.drawerOpen && (
                        <div className="drawer open">
                            <GDDetailView
                                type="report"
                                data={this.state.caseData[this.state.selectedKeyIndex]}
                                goBack={this.toggleDrawer}
                                goToPreviousRecord={this.goToPreviousRecord}
                                goToNextRecord={this.goToNextRecord}
                                structure={[].concat(this.state.reportMetaData)}
                                // preferences={{}}
                                recordCountSize={this.state.caseData.length}
                                selectedKeyIndex={this.state.selectedKeyIndex}
                                isOperationsReport={true}
                            />


                        </div>
                    )}
                </div>}
            </section >
        );
        /*  }
         else {
           return (
             <div>
             </div>
           );
         } */
    }
}

ReportView.propTypes = {
    dataColumns: PropTypes.array.isRequired,
    setNotification: PropTypes.func.isRequired,
    fetchDataColumns: PropTypes.func.isRequired,
    closeNotification: PropTypes.func.isRequired,
    dragOvertText: PropTypes.string,
};

const mapStateToProps = (state) => ({
    dataColumns: state.dataColumns?.columns,
    isSearchActive: state.appSearch.isSearchActive,
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDataColumns: (pageId) => dispatch(fetchDataColumns(pageId)),
        setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
        closeNotification: () => dispatch(closeNotificationBanner()),
        setDrawerOpenFlag: (isDrawerActive) => {
            dispatch(setDrawerOpenFlag(isDrawerActive));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportView));
